import React from 'react';
import { DeliveryAdvice, FreeText, IdentityFields, Note, SingleChoice } from './qualityAlertBlocks';

const NelQualityAlertForm = ({ template, fields, context, advice, onField, onContext, readOnly }) => (
  <div className="qa-form">
    <h3>{template.displayName}</h3>
    <Note text={template.intro} />
    <SingleChoice
      label="Provider"
      options={template.providers}
      other
      value={fields.provider}
      readOnly={readOnly}
      onChange={(value) => onField('provider', value)}
    />
    <SingleChoice
      label="Urgency"
      options={template.urgencyOptions}
      value={fields.urgency}
      readOnly={readOnly}
      onChange={(value) => onField('urgency', value)}
    />
    <SingleChoice
      label="Borough"
      options={template.boroughs}
      value={fields.borough}
      readOnly={readOnly}
      onChange={(value) => onField('borough', value)}
    />
    <IdentityFields fields={template.identityFields} context={context} readOnly={readOnly} onContext={onContext} />
    <FreeText
      label="Quality issue"
      multiline
      value={fields.narrative}
      readOnly={readOnly}
      onChange={(value) => onField('narrative', value)}
    />
    <Note text={template.sla} />
    <DeliveryAdvice advice={advice} />
  </div>
);

export default NelQualityAlertForm;
